export const APARTMENT_INFO_KEY = "client_apartment_info";
export class ApartmentInfoStorageManager {
    store(apartmentInfo) {
        const apartmentInfoDataStrign = JSON.stringify(apartmentInfo);
        localStorage.setItem(APARTMENT_INFO_KEY, apartmentInfoDataStrign);
    }
    restore() {
        const apartmentInfoDataString = localStorage.getItem(APARTMENT_INFO_KEY);
        if (apartmentInfoDataString === null) {
            return null;
        }
        return JSON.parse(apartmentInfoDataString);
    }
    erase() {
        localStorage.removeItem(APARTMENT_INFO_KEY);
    }
}
